import { readable } from "svelte/store";
export const userBearing = readable(0, set => {
    const onDeviceorientation = ({ alpha }) => set(alpha);
    window.addEventListener('deviceorientation', onDeviceorientation);
    return () => window.removeEventListener('deviceorientation', onDeviceorientation);
});
